import { useEffect, useCallback } from 'react';
import { useNavigate } from 'js/hooks/navigate';

export const useLegacyRedirectHandler = () => {
    const navigate = useNavigate();
    const handleRedirectClick = useCallback((event) => {
        const subject = event.target.closest('.fn-redirect');

        if (!subject) {
            return;
        }

        event.preventDefault();

        let url = subject.href && new URL(subject.href) || subject.dataset.href || subject.dataset.url;

        if (typeof url === 'object') {
            url = location.host === url.host ? url.pathname : url.href;
        }

        if (url) {
            navigate(url);
        }
    }, [navigate]);

    const handleRedirectOnEnter = useCallback((event) => {
        const { key, target } = event;

        if (key === 'Enter' && target.classList?.contains('fn-redirect') && target.tabIndex >= 0) {
            target.click();
        }
    }, []);

    useEffect(() => {
        document.body.addEventListener('click', handleRedirectClick);
        document.body.addEventListener('keydown', handleRedirectOnEnter);

        return () => {
            document.body.removeEventListener('click', handleRedirectClick);
            document.body.removeEventListener('keydown', handleRedirectOnEnter);
        };
    }, [handleRedirectClick, handleRedirectOnEnter]);
};
